var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconInsuranceHands({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6a.76.76 0 0 0-.75-.75h-3.75V1.5a.76.76 0 0 0-.75-.75h-3a.76.76 0 0 0-.75.75v3.75H6a.76.76 0 0 0-.75.75v3a.76.76 0 0 0 .75.75h3.75v3.75a.76.76 0 0 0 .75.75h3a.76.76 0 0 0 .75-.75V9.75H18a.76.76 0 0 0 .75-.75Zm-15 17.25-2-2.38a4.5 4.5 0 0 1-1-2.81v-5.17a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5v3.86",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 23.25v-3a4.46 4.46 0 0 0-.76-2.5L6.35 16a1.39 1.39 0 0 0-2-.44 1.4 1.4 0 0 0-.47 1.79l1.35 2.25m15.02 3.65 2-2.38a4.5 4.5 0 0 0 1-2.81v-5.17a1.5 1.5 0 0 0-1.5-1.5 1.5 1.5 0 0 0-1.5 1.5v3.88",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 23.25v-3a4.46 4.46 0 0 1 .76-2.5L17.65 16a1.39 1.39 0 0 1 2-.44 1.4 1.4 0 0 1 .47 1.79l-1.35 2.25",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconInsuranceHands);
export default __webpack_public_path__ + "static/media/streamline-icon-insurance-hands.ed5b41c6.svg";
export { ForwardRef as ReactComponent };